<script lang="ts" setup>
import type { IconName } from '~ds/lib/icons';

import { Icon } from '~ds/components/ui/icon';

interface Props {
  ariaLabel?: string;
  link: string;
  iconPath: IconName;
}

withDefaults(defineProps<Props>(), {
  ariaLabel: '',
});
</script>

<template>
  <a
    class="border-foreground text-foreground flex aspect-square size-12 items-center justify-center rounded-full border-2 bg-white p-2 shadow-[0_0_6px_rgba(255,255,255,0.4)] transition-all duration-200 hover:scale-105 hover:shadow-[0_4px_12px_rgba(0,0,0,0.5)]"
    :href="link"
    target="_blank"
  >
    <Icon :name="iconPath" size="2xl" />
  </a>
</template>
